<template>
  <div class="all-caught-up">
    <div class="check-circle">
      <i class="fa fa-check"></i>
    </div>
    <h3 class="title">All caught up!</h3>
    <p class="subtitle">No unread conversations right now.</p>
    <button type="button" class="show-all-link" @click="$emit('show-all')">
      Show all conversations
    </button>
  </div>
</template>

<script>
export default {
  name: 'AllCaughtUpEmptyState',
}
</script>

<style scoped lang="scss">
.all-caught-up {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  color: #475569;
}

.check-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f0fdf4;
  color: #15803d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(21, 128, 61, 0.08);
}

.title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px;
}

.subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 16px;
}

.show-all-link {
  background: transparent;
  border: none;
  color: #15803d;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background 0.15s ease;

  &:hover {
    background: #f0fdf4;
  }

  &:focus-visible {
    outline: 2px solid #15803d;
    outline-offset: 2px;
  }
}
</style>
